import React, { useState } from "react";
import { connect } from "react-redux";
import {
  DropDownIcon,
  BenchmarkIcon,
  BenchmarkOptions,
  BenchmarkOption,
  PopoverHeader,
  PopoverTabs,
  PopoverDescription,
} from "./style.js";
import Popover from "@material-ui/core/Popover";
import Radio from "@material-ui/core/Radio";
import Checkbox from "@material-ui/core/Checkbox";
import { magnetWorkSettingsOperations } from "../../../../redux/magnetWorkSettings";
import { getBenchmarkLabel } from "../../../../lib/utils";
import { magnetFooterActions } from "../../../../redux/magnetFooter";
import Fade from "@material-ui/core/Fade";

function BenchmarkPopover({
  unit,
  magnetWorkSettings,
  magnetReport,
  dispatch,
}) {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const generalBenchmark = magnetReport.workSettingBenchmarks.split(",")[0];
  const magnetWorkSetting = magnetWorkSettings[unit];
  const selectedBenchmarks = magnetWorkSetting.selectedBenchmarks;
  const appliedBenchmark = magnetWorkSetting.appliedBenchmark;

  const onSelectedBenchmarksChange = (event) => {
    const benchmark = event.target.value;
    let benchmarks = [...selectedBenchmarks];
    const indexOf = benchmarks.indexOf(benchmark);
    if (indexOf === -1) {
      benchmarks.push(benchmark);
    } else {
      benchmarks = [
        ...benchmarks.slice(0, indexOf),
        ...benchmarks.slice(indexOf + 1),
      ];
    }
    dispatch(magnetWorkSettingsOperations.selectBenchmarks(unit, benchmarks));
    if (appliedBenchmark === benchmark) {
      dispatch(
        magnetWorkSettingsOperations.applyBenchmark(unit, generalBenchmark)
      );
    }
    dispatch(magnetFooterActions.showFooter());
  };

  const onAppliedBenchmarkChange = (event) => {
    dispatch(
      magnetWorkSettingsOperations.applyBenchmark(unit, event.target.value)
    );
  };

  return (
    <React.Fragment>
      <DropDownIcon onClick={handleClick} />
      <Popover
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        TransitionComponent={Fade}
      >
        <PopoverHeader>
          <BenchmarkIcon />
          Benchmarks
        </PopoverHeader>
        <PopoverTabs
          tabs={[
            {
              name: "Available",
              content: (
                <React.Fragment>
                  <PopoverDescription>
                    Select available benchmarks to test
                  </PopoverDescription>
                  <BenchmarkOptions
                    aria-label="selectedBenchmarks"
                    name="selectedBenchmarks"
                  >
                    {magnetReport.workSettingBenchmarks
                      .split(",")
                      .map((benchmark, index) => (
                        <BenchmarkOption
                          key={benchmark}
                          value={benchmark}
                          control={
                            <Checkbox
                              color="primary"
                              checked={selectedBenchmarks.includes(benchmark)}
                              onChange={onSelectedBenchmarksChange}
                            />
                          }
                          label={
                            getBenchmarkLabel(benchmark, unit)
                          }
                          disabled={index === 0}
                        />
                      ))}
                  </BenchmarkOptions>
                </React.Fragment>
              ),
            },
            {
              name: "Applied",
              content: (
                <BenchmarkOptions
                  aria-label="appliedBenchmark"
                  name="appliedBenchmark"
                  value={appliedBenchmark}
                  onChange={onAppliedBenchmarkChange}
                >
                  {selectedBenchmarks.map((benchmark, index) => (
                    <BenchmarkOption
                      key={benchmark}
                      value={benchmark}
                      control={<Radio color="primary" />}
                      label={
                        getBenchmarkLabel(benchmark, unit)
                      }
                    />
                  ))}
                </BenchmarkOptions>
              ),
            },
          ]}
        />
      </Popover>
    </React.Fragment>
  );
}

export default connect((store) => {
  return {
    magnetFooter: store.magnetFooter,
    benchmarks: store.benchmarks,
  };
})(BenchmarkPopover);



// WEBPACK FOOTER //
// ./src/pages/MagnetReport/components/BenchmarkPopover/index.jsx